import React from "react";
import "./PrivacyPage.css";

export default function PrivacyPage() {
  return (
    <div>
      <h3>
        Privacy & Policy <i class="fas fa-user-secret text-primary"></i>
      </h3>
      <hr />
      <img
        className="privacyImg"
        src="https://cdn2.iconfinder.com/data/icons/metaverse/512/metaverse-virtual-world-19-512.png"
        alt=""
        srcset=""
      />
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae
        eligendi earum maiores consectetur et, accusamus velit tempora. Alias
        explicabo, eveniet expedita illo porro suscipit fugiat non distinctio
        laudantium nobis numquam ipsum sint provident fugit aperiam nihil
        voluptatem tempora recusandae officiis in a. Quos est quis ducimus,
        quaerat accusantium necessitatibus nulla vel reprehenderit iste quisquam
        veritatis ad voluptatum nesciunt repudiandae inventore eius ex itaque
        incidunt ullam deserunt mollitia quas facere aliquam voluptatibus! Nemo
        obcaecati necessitatibus ullam minus fuga optio perferendis dolores
        quisquam, repudiandae non consectetur eius cum placeat. Saepe ullam quae
        neque optio? Pariatur, tenetur fugit? Rerum esse minus quia eligendi
        vitae quis ut consequatur exercitationem, nihil sed! Enim tempore
        similique assumenda molestias perferendis laboriosam eos exercitationem
        expedita, quas magnam? Voluptatibus nostrum dignissimos, aspernatur quam
        esse vero fugit laudantium et sapiente maxime veniam deleniti molestias
        doloremque blanditiis ad? Labore ipsa a provident facere illum quasi?
        Ipsum quod ducimus temporibus reprehenderit neque quia corporis qui
        atque minus corrupti, quos assumenda iusto veritatis voluptates maxime
        fuga quidem debitis. Quis ex tempore illum impedit natus voluptas aut
        quasi officia laudantium, at possimus modi laboriosam earum expedita
        harum sit? In quo laudantium hic, quibusdam temporibus nemo quae quos
        necessitatibus. Doloremque aliquid voluptas aliquam possimus mollitia.
      </p>
    </div>
  );
}
